import { Component, OnInit, Injector } from '@angular/core';
import { PurchaseReportServiceProxy, 
        GetPurchaseReportOutput, GetPurchaseReportInput, 
        CommonLookupServiceProxy,
        DropDownLookupDto,
        PurchaseType
 } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from '@node_modules/@types/luxon';
import { FileDownloadService } from '@shared/utils/file-download.service';

@Component({
  selector: 'app-vendor-purchase',
  standalone: false,
  templateUrl: './vendor-purchase.component.html',
  styles: ``
})


export class VendorPurchaseComponent extends AppComponentBase implements OnInit {

  loading = false;
  locations: DropDownLookupDto[] = [];
  selectedLocations: any[] = [];
  dateRange: Date[] = [];
  purchaseReportOutput: GetPurchaseReportOutput;
  allvendors: DropDownLookupDto[];
  vendorId : 0;
  typeId : number = 1;

  constructor(
            injector: Injector,
        private lookupService: CommonLookupServiceProxy,
        private purchaseReportService: PurchaseReportServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _fileDownloadService: FileDownloadService,
      
    ){
      super(injector);
    }

  ngOnInit(): void {
    this.loadLocations();
    this.initializeDateRange();
    this.getReportDetails();
  }

  loadLocations()
  {
    this.lookupService.getAllLocationForTableDropdown().subscribe(res => {
        this.locations = res;
        const defaultLoc = this.locations.find( x => x.id == this.appSession.user.locationId);
        if (defaultLoc) this.selectedLocations = [defaultLoc];
    });
    
      this._commonLookupServiceProxy.getAllVendorForTableDropdown().subscribe((result) => {
          this.allvendors = result;
          this.vendorId = 0;
      });
      this.typeId = 1;

  }

  initializeDateRange() {
    const today = new Date();
    this.dateRange = [today, today];
  }

  getReportDetails() {

    if (!this.dateRange?.length) return;

    const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
    const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

    const locations = this.selectedLocations.length
      ? this.selectedLocations
      : this.locations;

    this.loading = true;

    let inputPurchaseReport = new GetPurchaseReportInput();
    inputPurchaseReport.startDate = startDate as any;
    inputPurchaseReport.endDate = endDate as any;
    inputPurchaseReport.locations = locations;
    inputPurchaseReport.purchaseType = this.typeId as PurchaseType;
    inputPurchaseReport.vendorId = this.vendorId;
    //vendorid
    //type
    this.purchaseReportService.getVendorPurchaseSummary(inputPurchaseReport)
    .subscribe(result => {
      this.purchaseReportOutput = result;
      console.log(result);
      //this.netProfitAmounts = result[0]?.netProfitAmounts || [];
      this.loading = false;
    });
  }

getReportDetailsExcel()
{
  if (!this.dateRange?.length) return;

    const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
    const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');

    const locations = this.selectedLocations.length
      ? this.selectedLocations
      : this.locations;

    this.loading = true;

    let inputPurchaseReport = new GetPurchaseReportInput();
    inputPurchaseReport.startDate = startDate as any;
    inputPurchaseReport.endDate = endDate as any;
    inputPurchaseReport.locations = locations;
    inputPurchaseReport.purchaseType = this.typeId as PurchaseType;
    inputPurchaseReport.vendorId = this.vendorId;
    //vendorid
    //type
    this.purchaseReportService.getVendorPurchaseSummaryExportExcel(inputPurchaseReport)
    .subscribe(result => {
      this._fileDownloadService.downloadTempFile(result);
      this.loading = false;
    });
}


}